import React from 'react';
import './AboutMe.css';
import { Heart, Rocket, Code } from 'lucide-react';
import img2 from '../assets/people/img2.jpg';
import img4 from '../assets/people/img4.jpg';
import img6 from '../assets/people/img6.jpg';

const AboutMe = () => {
  return (
    <div className="about-me-page">
      <div className="bg-dots"></div>
      
      <main className="container about-content">
        {/* Intro Section - Creative Hero */}
        <section className="about-hero-creative">
          <div className="hero-visual">
            <div className="image-frame">
              <img src={img6} alt="Gowthama Pandian" />
              <div className="accent-box"></div>
            </div>
          </div>
          <div className="hero-text-content">
            <div className="badge-name">Freelance Developer & Naturalist</div>
            <h1>Gowthama Pandian</h1>
            <p className="intro-para">
              I am studying <strong>M.Sc. Computer Science</strong> at Rajapalayam Rajus' College. 
              I find my balance between the digital precision of code and the beautiful complexity of nature.
            </p>
          </div>
        </section>

        {/* Passion Section - Modern Split */}
        <section className="modern-split">
          <div className="split-text card-glass">
            <div className="section-icon"><Heart size={32} /></div>
            <h2>Passion for Biodiversity</h2>
            <p>
              For me, biodiversity is more than just something beautiful to look at. It is a living system that we need to actively monitor and understand. When I am out in the field tracking dragonflies and damselflies, I see how perfectly connected nature truly is.
            </p>
            <p>
              My goal is to build the digital tools needed to protect them—from mobile apps for field data to web dashboards. Every line of code I write is a step toward protecting our natural world.
            </p>
          </div>
          <div className="split-image-container">
            <img src={img2} alt="Nature and Code" className="floating-img" />
            <div className="floating-icon icon-code"><Code size={24} /></div>
          </div>
        </section>

        {/* Exploration Section - Overlap Card */}
        <section className="overlap-section">
          <div className="overlap-image">
            <img src={img4} alt="Field Exploration" />
          </div>
          <div className="overlap-card card-glass">
             <div className="section-icon"><Rocket size={32} /></div>
             <h2>Field Exploration</h2>
             <p>
               Field exploration is about being fully present in nature. Observing dragonflies and damselflies in their natural habitats teaches me things I could never learn from a book. 
             </p>
             <p>
               Every time I visit a location, I learn how these insects interact with their surroundings. It takes patience and focus, but experiencing the ecosystem firsthand is the most beautiful reward.
             </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AboutMe;
